module.exports = __webpack_public_path__ + "images/map-style-6-c9866b25a8d4a23a3c84636a891a66c1.jpg";